import React from 'react'
import { Section, Title, Copy } from './index.styled'

const BottomBlackSection = ({ className }) => {
  const text = [
    'Discover Kanai',
    'Each of Kanai’s resorts offers a distinct stay and unique experiences. What all of the resorts have in common are uncompromising service, quality-of-life-improving design, reverence for the natural environment, world-class spa, wellness and fitness facilities, and superb, varied cuisine.'
  ]

  return (
    <Section className={[className, 'black'].join(' ')}>
      <Title className='fadeIn'>{text[0]}</Title>
      <Copy className='fadeIn'>{text[1]}</Copy>
    </Section>
  )
}

export default BottomBlackSection
